import apiCore from '../../utils/api-core';

export function getAccessToken(query) {
	return apiCore.get(`/api/v1/integrations/request-token?${query}`);
}

export function removeUserIntegration(data) {
	return apiCore.delete('/api/v1/integrations', data);
}

export function getIntegration(type) {
	return apiCore.get(`/api/v1/integrations/get-app?type=${type}`);
}

export function integrateCalendly(noTokenData) {
	return apiCore.post('/api/v1/integrations/no-token', noTokenData);
}

export function integrateCronofy(data) {
	return apiCore.post('/api/v1/integrations/cronofy', data);
}

export function getUserSettings(userId) {
	if(userId){
		return apiCore.get(`/api/v1/integrations/settings/${userId}`);
	}

	return apiCore.get('/api/v1/integrations/settings');
}

export function setUserSettings(data) {
	return apiCore.post('/api/v1/integrations/settings', data);
}

export function updateOfficeHours(userId, data) {
    return apiCore.put(`/api/v3/users/${userId}/office-hours`, data);
}

export function updateInviteMessage(userId, data) {
    return apiCore.put(`/api/v3/users/${userId}/interview-settings/invite-message`, data);
}

export function updateNoSlotsMessage(userId, data) {
    return apiCore.put(`/api/v3/users/${userId}/interview-settings/no-slots-message`, data);
}

export function updateConfirmedMessage(userId, data) {
    return apiCore.put(`/api/v3/users/${userId}/interview-settings/confirmed-message`, data);
}

export function updateCancelledMessage(userId, data) {
    return apiCore.put(`/api/v3/users/${userId}/interview-settings/cancelled-message`, data);
}

export function updateFollowupMessages(userId, data) {
    return apiCore.put(`/api/v3/users/${userId}/interview-settings/followup-messages`, data);
}

export function updateEventReminders(userId, data) {
    return apiCore.put(`/api/v3/users/${userId}/interview-settings/event-reminders`, data);
}

export function getEventRemindersPendingCount(userId) {
    return apiCore.get(`/api/v3/users/${userId}/interview-settings/event-reminders/pending-count`);
}

export function cancelScheduledMessage(id) {
    return apiCore.post(`/api/v3/scheduled-messages/${id}/cancel`);
}

export function sendScheduledMessageNow(id) {
    return apiCore.post(`/api/v3/scheduled-messages/${id}/send-now`);
}

export function muteContactEventReminders(contactId, muted) {
    return apiCore.put(`/api/v3/contacts/${contactId}/mute-event-reminders`, { muted });
}

export function updateCalendarSettings(userId, data) {
    return apiCore.put(`/api/v3/users/${userId}/interview-settings/calendar`, data);
}

export function integrateMerge(data) {
	return apiCore.post('/api/v1/integrations/merge', data);
}

export function getSchedContactsAffectedByUserSetting() {
	return apiCore.get('/api/v1/integrations/contacts/schedule/affected');
}